import { AlarmType, BaseExportType } from '@shared/models';

export const applicationPaths = {
  users: {
    accessProfile: ({ userId }: { userId: string }) => `users/${userId}/accessProfile`,
  },
  sites: {
    siteList: 'sites',
    selectedSite: ({ siteId }: { siteId: string }) => `sites/selected/${siteId}`,
    selectedList: 'sites/selected/list',
    selectedListLoad: ({ listId }: { listId: string }) =>
      listId ? `sites/selected/list/load?siteListId=${listId}` : 'sites/selected/list/load',
    selectedListId: ({ listId }: { listId: string }) => `sites/selected/list/${listId}`,
  },
  siteInformation: {
    siteDetails: ({ siteId }: { siteId: string }) => `sites/${siteId}/information`,
    coordinates: 'sites/coordinate',
    siteNote: ({ siteId }: { siteId: string }) => `sites/${siteId}/note`,
    photo: ({ siteId, photoId }: { siteId: string; photoId?: string }) => `sites/${siteId}/photo/${photoId ?? ''}`,
    photos: ({ siteId }: { siteId: string }) => `sites/${siteId}/photo`,
    //
    siteChannels: ({ siteId }: { siteId: string }) => `sites/${siteId}/information/channels`,
    siteChannelMeter: ({ siteId, channelId }: { siteId: string; channelId: string }) =>
      `sites/${siteId}/channel/${channelId}/meter`,
    //
    siteAlarms: ({ siteId }: { siteId: string }) => `sites/${siteId}/information/alarms`,
    siteAlarmsMicrolog: ({ siteId }: { siteId: string }) =>
      `sites/${siteId}/information/alarms/microlog/triggeractions`,
    siteStandardAlarms: ({ siteId, variant }: { siteId: string; variant: AlarmType }) =>
      `sites/${siteId}/information/alarms/${variant}`,
    //
    siteCommands: ({ siteId }: { siteId: string }) => `sites/${siteId}/commands`,
    sitePrv: ({ siteId }: { siteId: string }) => `sites/${siteId}/prv`,
  },
  accounts: {
    mainAccount: 'accounts/profile',
    subAccounts: ({ accountId }: { accountId: string }) => `accounts/${accountId}/subAccounts`,
    getAccAutocomplete: 'Accounts/search',
    getAccountById: ({ accountId }: { accountId: string }) => `Accounts/${accountId}`,
    permissions: 'Accounts/profile/permissions',
    zones: ({ accountId }: { accountId: string }) => `accounts/${accountId}/zones`,
  },
  graph: {
    graphData: 'graph',
    graphUnits: 'graph/units',
    exportData: 'graph/export/data',
    exportSummary: 'graph/export/summary',
    exportFormats: 'graph/export/formats',
    transients: ({ siteId, transientID }: { siteId: string; transientID: String }) =>
      `graph/sites/${siteId}/transient/${transientID}`,
    getChannelsConfiguration: ({ siteId, deviceId }: { siteId: string; deviceId: string }) =>
      `graph/sites/${siteId}/devices/${deviceId}/config`,
  },
  audit: {
    audit: 'audit',
    auditUsers: 'audit/users',
    exportAudit: ({ type }: { type: BaseExportType }) => `audit/export/${type}`,
  },
  alarms: {
    alarms: 'alarms',
    alarmsFilters: 'alarms/filters',
    exportAlarms: ({ type }: { type: BaseExportType }) => `alarms/export/${type}`,
    acknowledgeAlarm: ({ siteId, alarmId }: { siteId: string; alarmId: string }) => `alarms/${siteId}/${alarmId}`,
    acknowledgeAllAlarms: 'alarms/acknowledge/all',
  },
  reports: {
    reports: 'report/list',
    fleetReport: 'report/fleet',
    fleetReportDefault: 'report/fleet/default',
  },
  preferences: {
    preferences: 'preferences',
    options: 'preferences/options',
  },
  translations: {
    translations: 'translations',
    live: (languageCode: string) => `${applicationPaths.translations.translations}/live/${languageCode}`,
  },
  featureFlags: {
    features: `features/account`,
  },
};
